/** 产品委外发料 — 发料情况（与 ERP statusMaterialRequisition 一致） */

export const MATERIAL_REQUISITION_STATUS = {
  NONE: 0,
  PARTIAL: 1,
  COMPLETE: 2,
  OVER: 3
}

export const MATERIAL_REQUISITION_STATUS_OPTIONS = [
  {
    label: '未收料',
    value: MATERIAL_REQUISITION_STATUS.NONE,
    color: 'white',
    backGroundColor: 'rgb(102, 102, 102)'
  },
  {
    label: '部分收料',
    value: MATERIAL_REQUISITION_STATUS.PARTIAL,
    color: 'white',
    backGroundColor: 'rgb(79,129,246)'
  },
  {
    label: '完全收料',
    value: MATERIAL_REQUISITION_STATUS.COMPLETE,
    color: 'white',
    backGroundColor: 'rgb(106, 168, 79)'
  },
  {
    label: '超量收料',
    value: MATERIAL_REQUISITION_STATUS.OVER,
    color: 'white',
    backGroundColor: 'rgb(106, 168, 79)'
  }
]

/** 发料情况筛选 → outsorRequisitionDocFilter.statusMaterialRequisition */
export function buildMaterialRequisitionStatusFilter(statusMaterialRequisition) {
  if (
    statusMaterialRequisition === '' ||
    statusMaterialRequisition === null ||
    statusMaterialRequisition === undefined
  ) {
    return {}
  }
  return { statusMaterialRequisition: Number(statusMaterialRequisition) }
}

export function getMaterialRequisitionStatusLabel(status) {
  const option = MATERIAL_REQUISITION_STATUS_OPTIONS.find(
    (item) => item.value === Number(status)
  )
  return option ? option.label : ''
}

/** 已发料（发料情况 != 0）时可收料 */
export function canReceiveByMaterialRequisitionStatus(source) {
  if (!source) return false
  const status = source.statusMaterialRequisition
  if (status === undefined || status === null || status === '') return false
  return Number(status) !== MATERIAL_REQUISITION_STATUS.NONE
}
